import { Table } from '@tiptap/extension-table';

export const ResizableTable = Table.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      resizable: true,
    };
  },

  addCommands() {
    return {
      ...this.parent?.(),
      insertTable({ rows = 3, cols = 3, withHeaderRow = true } = {}) {
        return ({ commands }) => {
          const createCell = (type: 'tableCell' | 'tableHeader') => ({
            type,
            content: [
              {
                type: 'paragraph',
                content: [
                  {
                    type: 'text',
                    text: ' ',
                  },
                ],
              },
            ],
          });

          const tableContent = [
            ...(withHeaderRow
              ? [
                  {
                    type: 'tableRow',
                    content: Array.from({ length: cols }, () =>
                      createCell('tableHeader'),
                    ),
                  },
                ]
              : []),
            ...Array.from({ length: rows }, () => ({
              type: 'tableRow',
              content: Array.from({ length: cols }, () =>
                createCell('tableCell'),
              ),
            })),
          ];

          return commands.insertContent({
            type: 'table',
            content: tableContent,
          });
        };
      },
    };
  },

  addAttributes() {
    return {
      ...this.parent?.(),
      class: {
        default: 'resizable-table w-full border border-zinc-700 text-white',
      },
    };
  },
});
